export const MED_BANNER_SHOW_TIMEOUT = 7 * 24 * 60 * 60 * 1000; // 7 days
export const MED_BANNER_CLOSE_TIMEOUT = 6 * 30 * 24 * 60 * 60 * 1000; // 6 month
export const MED_BANNER_SUBSCRIPTION_CREATED_TIMEOUT_SEC = 60 * 60 * 24 * 30; // one month in seconds
